<div class="points-summary-bar d-flex justify-content-between d-lg-none bg-quaternary">
  <!-- Back Button -->
  <div class="text-white cursor-pointer d-flex align-items-center d-lg-none" (click)="goBack()">
    <span class="icon material-icons fw-bold pe-2"> navigate_before</span>
    <span class="font-size-14 fw-bold">Back </span>
  </div>
  <!-- Points Bar -->
  <ng-container *notInPopulation="populations.U18">
    <div class="justify-content-center flex-grow-1 flex-shrink-1 h-100">
      <fgb-points-summary></fgb-points-summary>
    </div>
  </ng-container>
</div>
